import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Serve } from '../serviceApi';
import { Rating,Fab } from '@mui/material';
import {  FaWhatsapp } from 'react-icons/fa';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Services=()=> {
    return (<>
        <div className="servicehead">
            <h4>what you get.</h4>
            <h6>we cover both the editing and framing.</h6>
        </div>
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
                {Serve.map((img, index) => {
                          const{image,rating,price,size,naira}=img
                          return (
        <Grid item xs={12} md={6}  key={index}>
                  <Item>
                              <Card  sx={{ maxWidth: 345,textAlign:'center' ,margin: 'auto',}}>
      <CardMedia
        sx={{ height:'30rem',objectFit:'cover',textAlign:'center' }}
        image={image}
      />
                                          <CardContent>
                                              <Rating
                                                  name='rating'
                                                  value={rating}
                                              />
                                              <Typography gutterBottom variant="h5" component="div">
                                              Frame Size :  {size}
        </Typography>
                                              <Typography gutterBottom variant="h5" component="div">
                                                  <img className='naira' src={naira} alt="naira" /> {price}
        </Typography>
       
      </CardContent>
      <CardActions>
                                              <a href="https://wa.me/message/7QOIJVDLJT5XO1">
                                                  <Fab variant="extended">
  <FaWhatsapp className='gb' />
</Fab>

        </a>
                                                  
      </CardActions>
    </Card>
          </Item>
        </Grid>
                          )
                      })}

      </Grid>
    </Box>
  </>
  );
}

export default Services;